export default __webpack_public_path__ + "pdf/vozvrat.caa1a234.pdf";